module.exports = __webpack_public_path__ + "static/media/data.6022c972.png";